module.exports = __webpack_public_path__ + "static/media/Mmain_bg.bd4d200b.png";